module.exports = __webpack_public_path__ + "img/Ramnath.Siva.2.9e83db71.jpg";